import { Event, PageviewParams, Section, Subsection, InteractionParams } from './types'
import { LIVE_SOURCE_BY_CREATED_FROM } from './constants'

import LanguageHelper from 'common/helpers/language'
import { isProduction } from 'common/helpers/settings/index'
import { CreatedFrom } from 'modules/transmission/types'

declare global {
  interface Window {
    dataLayer?: []
  }
}

const dataLayer: Record<string, unknown>[] = !isProduction() || !window.dataLayer ? [] : window.dataLayer

class GtagHelper {
  static sendPageView = ({ userId, subsection, subsection2, logged, liveSource }: PageviewParams) => {
    if (!subsection) {
      return
    }

    const event = {
      userId,
      subsection,
      subsection2,
      logged,
      language: LanguageHelper.language,
      event: Event.PAGEVIEW,
      section: Section.ATTENDEE,
      ...(liveSource && { liveSource })
    }

    dataLayer.push(event)
  }

  static getLiveSource(createdFrom: CreatedFrom) {
    return LIVE_SOURCE_BY_CREATED_FROM[createdFrom]
  }

  static interaction = ({ action, category, label }: InteractionParams) => {
    dataLayer.push({
      'event': Event.INTERACTION,
      'event_category': category,
      'event_action': action,
      'event_label': label
    })
  }
}

export default GtagHelper
export { Subsection }
